import React, { useState } from "react";
import { MessageCircle, Send } from "lucide-react";

const WhatsappPanel = () => {
    const [phone, setPhone] = useState("");

    const handleInput = (e) => {
        let value = e.target.value
            .replace(/[\s\-\(\)]/g, "")
            .replace(/\D/g, "");
        if (value.startsWith("0")) value = value.slice(1);
        if (value.startsWith("91") && value.length > 10) value = value.slice(2);
        if (value.startsWith("91") && value.length === 10) value = value.slice(2);
        if (value.length === 1 && !/[6-9]/.test(value[0])) value = "";
        if (value.length > 10) value = value.slice(0, 10);
        setPhone(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const cleanPhone = phone.replace(/\s/g, "");
        if (!/^[6-9]\d{9}$/.test(cleanPhone)) {
            alert("Please enter a valid 10-digit Indian mobile number (starting with 6-9).");
            return;
        }

        // Data for the message
        const baseUrl = "https://wa.me/918709364253";
        const pageUrl = window.location.href;
        const currentTime = new Date().toLocaleString();

        // Constructing the encoded message
        const message =
            `Hello! I'm interested in the Free IAS Topper Session.%0A%0A` +
            `*My Phone:* ${cleanPhone}%0A` +
            `*From Page:* ${pageUrl}%0A` +
            `*Request Time:* ${currentTime}`;

        window.open(
            `${baseUrl}?text=${message}`,
            "_blank",
            "noopener,noreferrer",
        );
    };

    return (
        <div className="w-full max-w-4xl my-4 mx-auto flex flex-col md:flex-row items-center">
            {/* Right Side: Form Content */}
            <div className="flex-1 w-full">
                <div className="mb-2">
                    <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight">
                        Get Free{" "}
                        <span className="text-yellow-500">IAS Topper</span>{" "}
                        Session
                    </h1>
                    <p className="text-gray-500 text-sm md:text-base">
                        Enter your WhatsApp number to receive the exclusive
                        session link instantly.
                    </p>
                </div>

                <form
                    onSubmit={handleSubmit}
                    className="flex flex-col sm:flex-row gap-3"
                >
                    <div className="relative flex-1">
                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-bold text-sm border-r pr-3 border-gray-200">
                            +91
                        </span>
                        <input
                            type="tel"
                            value={phone}
                            onChange={handleInput}
                            onBlur={(e) => {
                                const value = e.target.value;
                                if (value.length === 10 && /^[6-9]\d{9}$/.test(value)) {
                                    e.target.value = value.replace(/(\d{5})(\d{5})/, "$1 $2");
                                }
                            }}
                            onFocus={(e) => {
                                e.target.value = e.target.value.replace(/\s/g, "");
                            }}
                            placeholder="Enter phone number"
                            pattern="[6-9][0-9]{4}\s?[0-9]{5}"
                            className="w-full pl-16 pr-4 py-2 rounded-xl border-2 border-gray-100 bg-gray-50 outline-none transition-all focus:border-yellow-500"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="bg-yellow-400 hover:bg-yellow-500 text-black px-8 py-2 rounded-xl font-bold flex items-center justify-center gap-2 transition-all group cursor-pointer"
                    >
                        <span>Submit</span>
                        <Send
                            size={18}
                            className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                        />
                    </button>
                </form>
            </div>
        </div>
    );
};

export default WhatsappPanel;
